import React, { FC } from 'react';
import cx from 'classnames';
import { ListItemIcon, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AllowedTo } from 'common/components/AllowedTo/AllowedTo';
import { CustomTheme } from 'common/ui/interfaces';

const useStyles = makeStyles((theme: CustomTheme) => ({
  menuItem: {
    '&.Mui-disabled': {
      '&:has(.menu-item-warning)': {
        opacity: '1 !important',
        '& .menu-item-icon': {
          opacity: '0.5 !important',
        },
        '& p': {
          opacity: '0.5 !important',
        },
        '&:hover': {
          backgroundColor: 'inherit',
          '& .menu-item-icon svg': {
            color: 'inherit',
            '& path': {
              fill: 'inherit',
            },
          },
        },
      },
    },
    '&:hover:not(.Mui-disabled)': {
      '& svg': {
        color: theme.palette.background.paper,
        '& path': {
          fill: theme.palette.background.paper,
        },
      },
      '& .MuiListItemIcon-root': {
        color: theme.palette.background.paper,
      },
      '& p': {
        color: theme.palette.background.paper,
      },
    },
    '& .MuiListItemIcon-root:first-child': {
      marginRight: theme.spacing(1),
    },
  },
}));

interface IActionItem {
  children: React.ReactNode;
  icon?: JSX.Element;
  disabled?: boolean;
  divider?: boolean;
  onClick?: () => void;
  className?: string;
  id?: string;
}

const ActionItem: FC<IActionItem> = ({
  children,
  icon,
  disabled,
  divider,
  className,
  onClick,
  id,
}) => {
  const classes = useStyles();

  return (
    <MenuItem
      id={id}
      className={cx(classes.menuItem, className)}
      onClick={onClick}
      disabled={disabled}
      divider={divider}
    >
      <AllowedTo perform={!!icon}>
        <ListItemIcon className="menu-item-icon">{icon}</ListItemIcon>
      </AllowedTo>
      {children}
    </MenuItem>
  );
};

export default ActionItem;
